<template>
  <div class="red-packet-container">
    <van-nav-bar
        fixed
        title="红包中心"
        left-arrow
        @click-left="$router.back()"
    />

    <div class="content-wrapper">
      <div class="header-image" style="
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
    border-radius: 0 0 10px 10px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1);
">
        <img class="title-image"
             src="/static/image/xiangqing@2x.8b5b315d4cf3a4593fab14da84b35192.jpg"
             alt="抢红包活动图标"
             style="
             max-width: 100%;
             height: auto;
             filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
             transition: transform 0.3s ease;
         "
             onmouseover="this.style.transform='scale(1.05)'"
             onmouseout="this.style.transform='scale(1)'">
      </div>

      <div class="info-section">
        <div class="times-info">
          <p>剩余领取次数&nbsp;<span class="highlight">{{ userredpacket.sendnums < 0 ? 0 : userredpacket.sendnums }}</span>&nbsp;次，
            已领取&nbsp;<span class="highlight">{{ userredpacket.acquirednum }}</span>&nbsp;次</p>
        </div>

        <div class="max-times-info">
          <p>当前最多可领取&nbsp;<span class="highlight">{{ userredpacket.max_times }}</span>&nbsp;次，
            <span>快去满足条件吧！</span></p>
        </div>
      </div>

      <div class="activity-rules">
        <table v-if="userredpacket.rules.length > 0">
          <thead>
          <tr>
            <th>活动时间</th>
            <th>累计充值金额</th>
            <th>红包次数</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in userredpacket.rules" :key="index">
            <td>{{ item.start_time }} ~ {{ item.end_time }}</td>
            <td>{{ item.day_flow }}-{{ item.flow_money }}</td>
            <td>{{ Math.floor(item.recharge) }}</td>
          </tr>
          </tbody>
        </table>

        <div class="rules-details">
          <h3 class="highlight">领取规则：</h3>
          <p>1.抢到红包后，系统自动派彩，<span class="highlight">秒到账</span>，达到流水倍数即可取款；</p>
          <p>2.领取红包条件：充值金额需要在规定的活动日期（美东时间）范围内，根据充值累计金额，获取抢红包次数，即可抢对应次数的红包；</p>
        </div>
      </div>

      <div class="activity-description">
<!--        <p><strong>XC-SPORTS</strong></p>-->
        <p>
          <strong>注意：<strong>抢红包</strong>北京时间为每天早上10点到12点，存款计算为前一天12点到今天10点，谢谢~</strong><br/>
          每日百万现金红包！存款越多，机会越多，红包享不停，惊喜抢不停，还等什么？快快叫上好友一起分享吧！！<br/>
        </p>
        <p>1、会员必须在指定的活动日期（美东时间）范围内，根据充值累计金额，即可获得对应抢红包次数。若在规定的时间范围内没有达到存款金额范围，则不计算抢红包次数，逾期作废！</p>
        <p>2、所有的活动优惠特为玩家而设，如发现任何团体或个人，以不诚实的方式套取红利或任何威胁、滥用公司优惠等行为，公司保留冻结、取消该团体或个人账户及账户结余的权利。</p>
        <p>3、XC-SPORTS保留所有解释权，在任何时候都可以更改、停止、取消优惠活动。</p>
      </div>
      <button class="get-red-packet-btn" @click="changShow" style="
    background-color: #ea0909;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    transition: background-color 0.3s;
   ">抢红包</button>
    </div>

    <!-- Popup Dialogs -->
    <div class="popup-dialog" v-if="weikaishi">
      <div class="dialog-content">
        <p>活动还没开始，请静待活动开始。</p>
        <button class="close-btn" @click="closeAll">关闭</button>
      </div>
    </div>

    <div class="popup-dialog" v-if="end">
      <div class="dialog-content">
        <p>请静待下次活动。</p>
        <button class="close-btn" @click="closeAll">关闭</button>
      </div>
    </div>

    <div class="popup-dialog" v-if="zhongjiang">
      <div class="dialog-content">
        <p>恭喜您</p>
        <p>抢到<span class="highlight big-amount">{{ mey }}</span>元</p>
        <button class="close-btn" @click="closeAll">关闭</button>
      </div>
    </div>

    <div class="popup-dialog" v-if="henbaoqian">
      <div class="dialog-content">
        <p>{{ message }}</p>
        <button class="action-btn" @click="$parent.goNav('/recharge')">立即充值</button>
        <button class="close-btn" @click="closeAll">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hongbao',
  data() {
    return {
      show: false,
      redpacketList: [],
      page: 1,
      redpacketShowData: {},
      userredpacket: {rules: []},
      weikaishi: false,
      end: false,
      mey: 0,
      zhongjiang: false,
      henbaoqian: false,
      message: ''
    };
  },
  created() {
    this.getuserredpacket();
  },
  methods: {
    closeAll() {
      this.show = false;
      this.weikaishi = false;
      this.end = false;
      this.zhongjiang = false;
      this.henbaoqian = false;
      this.message = '';
    },
    changShow() {
      if (this.userredpacket.sendnums <= 0) {
        this.henbaoqian = true;
        this.message = '您暂未达到领取条件，快去完成吧！';
        return;
      }
      this.getwelfare();
    },
    getwelfare() {
      this.$parent.showLoading();
      this.$apiFun
          .post('/api/douserredpacket', {})
          .then(res => {
            if (res.code == 200) {
              this.mey = res.data.redpacketmoney;
              this.getuserredpacket();
              this.zhongjiang = true;
            } else {
              this.henbaoqian = true;
              this.message = res.message;
            }
            this.$parent.hideLoading();
          })
          .catch(() => {
            this.$parent.showTost(0, '服务器异常，请稍后再试');
            this.$parent.hideLoading();
          });
    },
    getuserredpacket() {
      this.$parent.showLoading();
      this.$apiFun.get('/api/userredpacket', {}).then(res => {
        if (res.code != 200) {
          this.$parent.showTost(0, res.message);
        }
        if (res.code == 200) {
          this.userredpacket = res.data;
        }
        this.$parent.hideLoading();
      });
    },
  }
};
</script>

<style scoped>
.red-packet-container {
  background: url(/static/image/bg123456.jpg) top center no-repeat;
  background-size: cover;
  min-height: 100vh;
  padding-top: 46px;
  position: relative;
}

.content-wrapper {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-image {
  text-align: center;
  margin: 20px 0;
}

.title-image {
  max-width: 200px;
  height: auto;
}

.info-section {
  background-color: #fff5e6;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.times-info, .max-times-info {
  text-align: center;
  margin: 10px 0;
  font-size: 14px;
}

.highlight {
  color: #ff6b00;
  font-weight: bold;
}

.activity-rules {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.activity-rules table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;
}

.activity-rules th, .activity-rules td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.activity-rules th {
  background-color: #ffefd5;
}

.rules-details {
  font-size: 13px;
  line-height: 1.6;
}

.activity-description {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
  font-size: 13px;
  line-height: 1.6;
}

.get-red-packet-btn {
  display: block;
  width: 200px;
  height: 50px;
  margin: 30px auto;
  background: url(/static/image/red-packet-btn.png) no-repeat center;
  background-size: contain;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.popup-dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.dialog-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  max-width: 80%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.big-amount {
  font-size: 24px;
  margin: 0 5px;
}

.close-btn, .action-btn {
  padding: 8px 20px;
  margin: 10px 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

.close-btn {
  background-color: #f0f0f0;
}

.action-btn {
  background-color: #ff6b00;
  color: white;
}

@media (max-width: 600px) {
  .content-wrapper {
    padding: 15px;
  }

  .activity-rules table {
    font-size: 12px;
  }

  .get-red-packet-btn {
    width: 160px;
    height: 40px;
  }
}
</style>